import { VisualizationSpec } from "react-vega";
import { Actions } from "vega-embed";
import { AnyMark } from "vega-lite/build/src/mark";
import { ByReceiverAbacusRow } from "../../redux/detections/detection-types";
import { isTimeWithinBounds } from "../../helpers/time";
import { VegaAutosized } from "../common/charts/VegaAutosized";
import { LOADING_INDICATOR_POSITION } from "./detection-consts";

type PropTypes = {
  byRxData: ByReceiverAbacusRow[];
  interval: number[];
  type: string;
  actions?: Actions;
  loading: boolean;
  timeUnit: "binnedutcyearmonthdate" | "binnedutcyearmonthdatehours";
};

function DetectionAbacus({ byRxData, interval, type, actions, loading, timeUnit }: PropTypes) {
  let xScale;
  let filteredData = byRxData;
  const rxDomain = [...new Set(byRxData.map(rx => rx.rx))].sort();
  if (interval?.length == 2) {
    const start = (interval?.[0] && new Date(interval[0]).toISOString()) || null;
    const end = (interval?.[1] && new Date(interval[1]).toISOString()) || null;
    filteredData = byRxData.filter(({ dt: time }) => isTimeWithinBounds({ time, start, end }));
    xScale = { domain: interval };
  } else {
    filteredData = byRxData;
    xScale = undefined;
  }

  let mark: AnyMark;
  let size: any;
  let color;

  if (type === "colour") {
    mark = "rect";
    size = undefined;
    color = {
      field: "count",
      type: "quantitative",
      title: "Detections",
      legend: { orient: "bottom" },
    };
  } else {
    mark = {
      type: "circle",
      opacity: 0.8,
      stroke: "black",
      strokeWidth: 1,
    } as AnyMark;
    size = {
      field: "count",
      type: "quantitative",
      title: "Detections",
      legend: { orient: "bottom" },
    };
    color = undefined;
  }

  const spec: VisualizationSpec = {
    data: { name: "byRx" },
    mark,
    height: { step: 35 },
    encoding: {
      x: {
        field: "dt",
        type: "temporal",
        timeUnit,
        axis: {
          title: "",
          bandPosition: 0,
          labelBound: true, // this prevents the axis labels from exceeding the chart container
        },
        scale: xScale,
      },
      size,
      color,
      y: {
        field: "rx",
        type: "nominal",
        axis: {
          title: "Receiver",
          minExtent: 50,
        },
        scale: { domain: rxDomain },
      },
    },
  };

  return (
    <VegaAutosized
      spec={spec}
      data={{ byRx: filteredData }}
      actions={actions}
      id="abacus"
      fit="width"
      loading={loading}
      loaderPosition={LOADING_INDICATOR_POSITION}
    />
  );
}

export default DetectionAbacus;
